export enum RedirectToEnum {
  PHYSICAL_ACTIVITY = 'PHYSICAL_ACTIVITY',
  MEASUREMENTS = 'MEASUREMENTS',
  INFO = 'INFO'
}
